import { LangText } from '@/components'
import { preFixImgUrl } from '@/utils';
import num01 from '@/assets/svg/num_01.svg'
import num02 from '@/assets/svg/num_02.svg'
import num03 from '@/assets/svg/num_03.svg'
import num04 from '@/assets/svg/num_04.svg'

const SERVICE_BACKGROUND =
  'eb0c7b060e7fa5170db79c3f98825805.png'

const SERVICE_ITEMS = [
  {
    numberImage: num01,
    phoneImage: '2db6fb351ba51b8f0eb465293a5feb66.png',
    titleKey: 'hanedaShop.services.items.taxFreePrice.title',
    hoverTextKey: 'hanedaShop.services.items.taxFreePrice.hoverText',
  },
  {
    numberImage: num02,
    phoneImage: 'c4dfef539378d934aa4496771b3574a1.png',
    titleKey: 'hanedaShop.services.items.authenticity.title',
    hoverTextKey: 'hanedaShop.services.items.authenticity.hoverText',
  },
  {
    numberImage: num03,
    phoneImage: '3fc0e86a1b2114fecc0b726b07d1b021.png',
    titleKey: 'hanedaShop.services.items.discounts.title',
    hoverTextKey: 'hanedaShop.services.items.discounts.hoverText',
  },
  {
    numberImage: num04,
    phoneImage: '2a76eb9a251bf1c73eff10685f70cbd6.png',
    titleKey: 'hanedaShop.services.items.benefits.title',
    hoverTextKey: 'hanedaShop.services.items.benefits.hoverText',
  }
] as const

const ServiceContent = () => (
  <section
    className="w-full bg-center bg-no-repeat bg-cover rounded-[80px_0_0_0] overflow-hidden h-[935px]"
    style={{ backgroundImage: `url(${preFixImgUrl(SERVICE_BACKGROUND)})` }}
  >
    <div className="mx-auto flex h-full w-[1200px] flex-col items-center pt-[60px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="hanedaShop.services.title"
          className="text-[36px] font-bold leading-[50px] text-white"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-[#E0E0E0]/20" />
      </div>

      <div className="mt-[36px] grid w-full grid-cols-4 gap-[24px]">
        {SERVICE_ITEMS.map((item) => (
          <article key={item.titleKey} className="flex flex-col items-center min-w-0 group">
            <div className="flex h-[60px] items-center justify-center">
              <img src={item.numberImage} alt="" className="object-contain w-auto h-full" aria-hidden />
            </div>
            <LangText
              lngKey={item.titleKey}
              className="mt-[-2px] text-[32px] font-medium leading-[38px] text-white font-smiley-sans "
            />

            <div className="relative mt-[36px] h-[538px] w-[265px] overflow-hidden">
              <img
                src={preFixImgUrl(item.phoneImage)}
                alt=""
                className="absolute inset-0 z-[1] h-full w-full object-contain"
                draggable={false}
              />

              <div
                className="absolute z-[2] overflow-hidden"
                style={{ top: 12, right: 12, bottom: 10, left: 12, borderRadius: 36 }}
              >
                <div className="absolute inset-x-0 bottom-0 h-[46%] translate-y-full bg-linear-to-b from-[#328BF8]/0 via-[#328BF8]/70 to-[#328BF8] opacity-0 transition-[transform,opacity] duration-500 ease-out group-hover:translate-y-0 group-hover:opacity-100">
                  <div className="flex h-full items-end justify-center pb-[30px]">
                    <div className="flex items-center gap-[8px] text-white">
                      <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-white text-[14px] font-bold text-primary">
                        ✓
                      </span>
                      <LangText lngKey={item.hoverTextKey} className="text-[16px] leading-[22px]" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ServiceContent
